// extracted by mini-css-extract-plugin
export default {"tabs":"e_76xbdOvJ","content":"j8pdlm8uJG"};